import { atom } from 'jotai';

import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * THE firmware modal id — every enqueue, dequeue and pacing check resolves
 * here (the launch queue's duplicate inline cast was folded into this constant,
 * OpenSpec `monorepo-shell-registry` task S3).
 *
 * Still a **local-regime id** (design D4): `FIRMWARE_UPDATE` is not a backend
 * `ModalId` enum member, so the cast stays until the ml-scribe enum catches up
 * and `pnpm run schema:dev` regenerates. Safe meanwhile because the modal is
 * enqueued without `showOnce`, so it never consults the backend-synced
 * `seenModalIds` set. The id STRING is frozen either way.
 */
export const FIRMWARE_MODAL_ID = 'FIRMWARE_UPDATE' as ModalId;

/** Shared between DeviceSection (write) and the global firmware update hook (read). */
export const pendingLocalFirmwareFileAtom = atom<string | null>(null);

/**
 * Per-session guard: true once the startup firmware modal has been enqueued
 * this sign-in session. Reset to false on sign-out so the next sign-in
 * re-triggers — mirrors the iOS `checkFirmwareUpdateOnStartup` behaviour.
 */
export const firmwareStartupSeenAtom = atom(false);

/**
 * Direct open, set by the DeviceSection banner. A click is a response the user
 * asked for, not an interruption the app chose, so it bypasses the modal queue
 * entirely — competing there let any equal-or-higher launch modal win the sort
 * and silently swallow the click.
 */
export const firmwareModalUserOpenAtom = atom(false);
